<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add">新增</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button>
				
			</template>
			
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				deleteId:'',//修改状态的id
				modal2: false,
				modal_loading: false,
				query: {//查询参数
					page: 0,
					size: 10
				},
				loading: false,
				total: 0,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '设备分类',
						key: 'macKindstString'
					},
					{
						title: '备注',
						key: 'remark'
					},
					{
						title: '状态',
						key: 'state',
						render: (h, params) => {
							if(params.row.state==true){
								return h("div","启用")
							}else{
								return h("div","禁用")
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}
				],
				data6: [{
					id: '1',
					createdTime: '',
					name: '',
					remark: '',
					state: ''
				}],
			}
		},
		methods: {
			update(id) { //修改
				 this.$router.push({
					name: 'jm/mac/mactype/update',
					query: {
						id: id
					}
				}) 
			},
			forbidden(id){
				this.deleteId=id
				this.modal2=true
			},
			add() {
				this.$router.push({
					name: 'jm/mac/mactype/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/type/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macTypes.totalElements
						_this.data6 = data.macTypes.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		components: {
			page
		},
		created() { //请求数据
			this.ajaxPage();
		}

	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/macType/list.vue